// extracted by mini-css-extract-plugin
module.exports = {"container":"Rules_container__3MlKA","accent":"Rules_accent__2FEeE","skeleton-anim":"Rules_skeleton-anim__MHX_4","fadeIn1":"Rules_fadeIn1__qw_d2"};